import { constants } from "../constants/redux-constants";

const initialState = {
  currentSubscription: {},
  availablePlans:[]
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.SUBSCRIPTION?.SET_CURRENT_SUBSCRIPTION:
      return {
        ...state,
        currentSubscription: action?.payload,
      };
    case constants?.SUBSCRIPTION?.SET_AVAILABLE_PLANS:
      return {
        ...state,
        availablePlans: action?.payload,
      };
    case constants?.SUBSCRIPTION?.RESET_SUBSCRIPTION:
      return {
        state: {},
      };

    default:
      return {
        ...state,
      };
  }
};

export default SubscriptionReducer;
